import { get, post, put } from '../utils/api';

// Every route is owner-checked server-side (the child must belong to the logged-in parent).
export const getSparksState = (childId) => get(`/sparks/${childId}/state`, true);
export const getSparksHistory = (childId, limit = 50) => get(`/sparks/${childId}/history?limit=${limit}`, true);
export const getShop = (childId) => get(`/sparks/${childId}/shop`, true);
export const getEarnedToday = (childId) => get(`/sparks/${childId}/earned-today`, true);
export const getHomeRates = (childId) => get(`/sparks/${childId}/home-rates`, true);
export const purchaseItem = (childId, itemKey) => post(`/sparks/${childId}/shop/purchase`, { itemKey }, true);
export const equipItems = (childId, equipped) => put(`/sparks/${childId}/equip`, { equipped }, true);
export const getLeaderboard = (childId) => get(`/sparks/${childId}/leaderboard`, true);
export const setLeaderboardOptOut = (childId, optOut) => put(`/sparks/${childId}/leaderboard-opt-out`, { optOut }, true);
export const sendTutorShoutout = (childId, reason) => post('/sparks/tutor/shoutout', { childId, reason }, true);

export const formatSparks = (n) => (Number(n) || 0).toLocaleString('en-GB');
